import React from "react";
import "../assets/popup.css";

function Popup({ message, onClose }) {
  return (
    <div className="confirmation-popup">
      <div className="confirmation-popup-content">
        <p>{message}</p>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

export default Popup;
